import React, { useState } from 'react';

import { FitContentSectionWrapper } from '../../ui/wrappers';
import { TitleWrapper } from '../../ui/titles';
import { H3 } from '../../ui/headings';
import { GridContainer } from '../../ui/grid';
import { FlexContainer } from '../../ui/flex';
import { projects, tabs } from '../../constants';
import { TabBadge, TabContainer, TabItem } from '../../ui/tab';

import ProjectCard from './ProjectCard';

const Projects = () => {
    const [activeTab, setActiveTab] = useState('all');

    const filteredProjects = activeTab === 'all' ? projects : projects.filter(project => project.type === activeTab);

    const getCount = tab => (tab === 'all' ? projects.length : projects.filter(p => p.type === tab).length);

    return (
        <FitContentSectionWrapper id='projects'>
            <FlexContainer $column $content='center' $gap='5em'>
                <TitleWrapper>
                    <H3>Projects</H3>
                </TitleWrapper>

                <GridContainer>
                    <TabContainer>
                        {tabs.map(tab => (
                            <TabItem
                                key={tab.key}
                                $active={activeTab === tab.key}
                                onClick={() => setActiveTab(tab.key)}
                            >
                                {tab.label}
                                <TabBadge>{getCount(tab.key)}</TabBadge>
                            </TabItem>
                        ))}
                    </TabContainer>

                    {filteredProjects.map((project, idx) =>
                        idx % 2 === 0 ? (
                            <ProjectCard key={idx} project={project} right />
                        ) : (
                            <ProjectCard key={idx} project={project} />
                        )
                    )}
                </GridContainer>
            </FlexContainer>
        </FitContentSectionWrapper>
    );
};

export default Projects;
